export type OverallAutoCheckState = 'yes' | 'no' | 'pending' | 'error'

export const mapDecisionStatusToOverall = (
  status?: number,
  approved?: boolean | null,
): OverallAutoCheckState => {
  if (status === 0) {
    return 'error'
  }
  if (status === 2) {
    if (approved === true) return 'yes'
    if (approved === false) return 'no'
    return 'error'
  }
  if (status === 1) return 'pending'
  return 'error'
}
